import { mediaUrl } from "../lib/api";

// sky, left, middle, right, ground, trees
const PALETTES = [
  ["#d9ecf2", "#9fb7a0", "#b8cbb0", "#8fa98f", "#6fb3c8", "#4f8150"],
  ["#e3ecef", "#a95b44", "#93a7aa", "#e8dcc3", "#7cbfd2", "#6ea56b"],
  ["#dbe7ec", "#b4644b", "#e2d4b6", "#bfb9ac", "#e7dfcf", "#5d8f5b"],
  ["#e0eaee", "#cfc6b4", "#b9b2a4", "#e2d4b6", "#9fd1dd", "#5d8f5b"],
  ["#dcebf0", "#a3b99c", "#8fae8a", "#c4d3bd", "#6fb3c8", "#4f8150"],
  ["#e6ecee", "#e8dcc3", "#b4644b", "#93a7aa", "#ddd5c4", "#6ea56b"],
  ["#e4ecef", "#c9b897", "#d9cdb5", "#b9b2a4", "#e3dccd", "#5d8f5b"],
  ["#dfeaee", "#a95b44", "#cfc6b4", "#93a7aa", "#c9dfb8", "#4f8150"],
  ["#e2ebee", "#b9b2a4", "#a95b44", "#d9cdb5", "#b8d4a5", "#6ea56b"],
  ["#e4ecef", "#cfc6b4", "#bfb9ac", "#e2d4b6", "#c9c4ba", "#5d8f5b"],
];

const hash = (s = "") => [...s].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7);

/** Illustrated placeholder used until a proposal has its own photo. */
export const Illustration = ({ variant = 0, muted = false }) => {
  const [sky, a, b, c, ground, tree] = PALETTES[Math.abs(variant) % PALETTES.length];
  return (
    <svg aria-hidden="true" viewBox="0 0 160 120" preserveAspectRatio="xMidYMid slice"
      style={{ display: "block", width: "100%", height: "100%", filter: muted ? "grayscale(.75) brightness(.95)" : "none" }}>
      <rect width="160" height="120" fill={sky} />
      <rect x="0" y="34" width="54" height="66" fill={a} />
      <rect x="6" y="44" width="42" height="40" fill="url(#tw)" />
      <rect x="54" y="52" width="44" height="48" fill={b} />
      <rect x="60" y="60" width="32" height="28" fill="url(#tw)" />
      <rect x="98" y="26" width="62" height="74" fill={c} />
      <rect x="104" y="36" width="50" height="48" fill="url(#tw)" />
      <rect x="0" y="96" width="160" height="24" fill={muted ? "#8d9599" : ground} />
      {!muted && (
        <>
          <rect x="34" y="70" width="4" height="30" fill="#6a5642" />
          <circle cx="36" cy="66" r="16" fill={tree} />
          <rect x="124" y="72" width="4" height="28" fill="#6a5642" />
          <circle cx="126" cy="68" r="15" fill={tree} />
        </>
      )}
    </svg>
  );
};

export const variantOf = (p) => (p?.illustration ?? hash(p?.id || p?.title || "")) % PALETTES.length;

export const Cover = ({ p, src, muted = false }) => {
  const url = src !== undefined ? src : p?.cover;
  if (url) {
    return <img src={mediaUrl(url)} alt="" loading="lazy" decoding="async" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
  }
  return <Illustration variant={variantOf(p)} muted={muted} />;
};

export const PatternDefs = () => (
  <svg width="0" height="0" aria-hidden="true" style={{ position: "absolute" }}>
    <defs>
      <pattern id="tw" x="0" y="0" width="10" height="12" patternUnits="userSpaceOnUse">
        <rect x="3" y="2" width="4" height="7" fill="#2b3740" opacity="0.75" />
      </pattern>
    </defs>
  </svg>
);
